import {Pipe, PipeTransform} from '@angular/core';
import {I18nextFormattersService} from 'app/core/services/i18next-formatters.service';

@Pipe({
    name: 'durationFormat',
})
export class DurationFormatPipe implements PipeTransform {
    constructor(private formats: I18nextFormattersService) {}

    transform(value: number): string {
        return this.formats.formatDuration(value || 0);
    }
}
